import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api, notifyError } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { CreditCard, AlertTriangle, Loader2, ArrowLeft } from "lucide-react";

export default function PayTRMock() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const planName = params.get("plan") || "Paket";
  const amount = params.get("amount");
  const [busy, setBusy] = useState(false);

  // Paket tutarı KDV hariç gelir; KDV (%20) ayrı satırda gösterilir,
  // tahsil edilen tutar KDV dahil toplamdır.
  const KDV_RATE = 0.2;
  const netAmount = Number(amount) || 0;
  const kdvAmount = netAmount * KDV_RATE;
  const grossAmount = netAmount + kdvAmount;
  const fmtTRY = (n) =>
    new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 2 }).format(n || 0);

  const confirm = async () => {
    setBusy(true);
    try {
      await api.post(`/billing/paytr-mock-confirm/${sessionId}`);
      toast.success("Ödeme alındı, paket aktif");
      navigate("/abonelik?paid=1");
    } catch (err) {
      notifyError(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-background grid-bg flex items-center justify-center p-6">
      <Card className="rounded-sm border-border max-w-md w-full p-6 sm:p-8 space-y-5" data-testid="paytr-mock-page">
        <div className="flex items-center gap-3">
          <div className="h-12 w-12 rounded-sm bg-[#0E8A7C] text-white flex items-center justify-center">
            <CreditCard className="h-6 w-6" />
          </div>
          <div>
            <div className="font-display font-bold text-2xl tracking-tight">PayTR</div>
            <div className="text-xs text-muted-foreground font-mono">{sessionId}</div>
          </div>
        </div>

        <div className="border-l-2 border-amber-500 bg-amber-500/10 p-3 text-xs flex items-start gap-2 rounded-sm">
          <AlertTriangle className="h-4 w-4 text-amber-600 shrink-0 mt-0.5" />
          <span>
            <strong>SİMÜLE EDİLEN ÖDEME:</strong> Şu an PayTR canlı API bilgileri girilmediği için
            ödeme akışı simüle ediliyor. Master panel "Ödeme Ayarları" sayfasından merchant
            bilgilerinizi girince gerçek ödeme aktif olacak.
          </span>
        </div>

        <div className="border-y border-border py-4 space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Paket</span>
            <span className="font-semibold">{planName}</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Paket Tutarı</span>
            <span className="font-semibold" data-testid="paytr-net">{fmtTRY(netAmount)}</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">KDV (%20)</span>
            <span className="font-semibold" data-testid="paytr-kdv">{fmtTRY(kdvAmount)}</span>
          </div>
          <div className="flex items-center justify-between pt-2 border-t border-border">
            <span className="text-muted-foreground text-sm">Toplam (KDV Dahil)</span>
            <span className="font-display font-black text-2xl tracking-tighter" data-testid="paytr-gross">
              {fmtTRY(grossAmount)}
            </span>
          </div>
        </div>

        <Button
          onClick={confirm}
          disabled={busy}
          className="w-full h-12 rounded-sm bg-[#0E8A7C] hover:bg-[#0E8A7C]/90 text-white"
          data-testid="paytr-confirm-btn"
        >
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Ödemeyi Tamamla (Simüle)"}
        </Button>

        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate("/abonelik?cancelled=1")}
          className="w-full rounded-sm"
          data-testid="paytr-cancel-btn"
        >
          <ArrowLeft className="h-4 w-4 mr-1" /> İptal
        </Button>
      </Card>
    </div>
  );
}
